import * as Role from '../../../../constants/role';
import * as Status from '../../../../constants/status';
import { isInspecaoMtBt } from 'utils';
import { isAnexoNsmp } from './nsmpRowTypes';
import { isDigitacaoHabilitada } from '../../../../helpers/digitacaoAntecipada';

export const isDigitadorVinculado = ({ userRole, digitadorId, userId }) =>
  userRole === Role.DIGITADOR && Boolean(digitadorId && userId && digitadorId === userId);

/** MT/BT: digitador vinculado pode pré-visualizar serviços/fotos antes de iniciar a digitação. */
export const isMtBtDigitadorPreview = ({
  tipoServicoId,
  userRole,
  digitadorId,
  userId,
  nsirStatus,
  digitacaoAntecipada,
}) =>
  isInspecaoMtBt(tipoServicoId) &&
  isDigitadorVinculado({ userRole, digitadorId, userId }) &&
  Status.canDigitar(nsirStatus) &&
  !isDigitacaoHabilitada({
    status: nsirStatus,
    digitadorId,
    userId,
    userRole,
    digitacaoAntecipada,
  });

export const isDigitadorEmDigitacao = ({
  nsirStatus,
  digitadorId,
  userId,
  userRole,
  digitacaoAntecipada,
}) =>
  isDigitacaoHabilitada({
    status: nsirStatus,
    digitadorId,
    userId,
    userRole,
    digitacaoAntecipada,
  });

export const getServicosShowEdit = ({
  nsirStatus,
  inspetorId,
  userId,
  userRole,
  digitadorId,
  tipoServicoId,
  digitacaoAntecipada,
}) => {
  const isInspetor = nsirStatus === Status.EM_INSPECAO && inspetorId === userId;
  const digitadorAtivo = isDigitadorEmDigitacao({
    nsirStatus,
    digitadorId,
    userId,
    userRole,
    digitacaoAntecipada,
  });
  const preview = isMtBtDigitadorPreview({
    tipoServicoId,
    userRole,
    digitadorId,
    userId,
    nsirStatus,
    digitacaoAntecipada,
  });
  return isInspetor || (digitadorAtivo && !preview);
};

export const getServicosShowView = ({
  isAdmin,
  nsirStatus,
  userRole,
  digitadorId,
  userId,
  tipoServicoId,
  digitacaoAntecipada,
}) => {
  if (isAdmin) return true;

  if (isMtBtDigitadorPreview({
    tipoServicoId,
    userRole,
    digitadorId,
    userId,
    nsirStatus,
    digitacaoAntecipada,
  })) {
    return true;
  }

  if (
    isDigitadorEmDigitacao({
      nsirStatus,
      digitadorId,
      userId,
      userRole,
      digitacaoAntecipada,
    }) &&
    isInspecaoMtBt(tipoServicoId)
  ) {
    return true;
  }

  return (
    nsirStatus !== Status.EM_INSPECAO &&
    nsirStatus !== Status.EM_DIGITACAO &&
    !(nsirStatus === Status.INSPECAO_FINALIZADA && userRole === Role.DIGITADOR)
  );
};

export const getServicosShowViewRow = (
  row,
  { nsirStatus, userRole, digitadorId, userId, tipoServicoId, isServiceRow, digitacaoAntecipada },
) => {
  if (isMtBtDigitadorPreview({
    tipoServicoId,
    userRole,
    digitadorId,
    userId,
    nsirStatus,
    digitacaoAntecipada,
  })) {
    return true;
  }

  if (
    isDigitadorEmDigitacao({
      nsirStatus,
      digitadorId,
      userId,
      userRole,
      digitacaoAntecipada,
    }) &&
    isInspecaoMtBt(tipoServicoId) &&
    isAnexoNsmp(row)
  ) {
    return true;
  }

  if (
    isDigitadorEmDigitacao({
      nsirStatus,
      digitadorId,
      userId,
      userRole,
      digitacaoAntecipada,
    }) &&
    isServiceRow(row)
  ) {
    return false;
  }

  return true;
};
